import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PipesModule } from '../pipes/pipes.module';
import { DirectivesModule } from '../directives/directives.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { AssignmentEditorComponent } from './editor/assignment-editor.component';
import { AssignmentEditorApp } from './assignment-editor.app';
import { AssignmentEditorView } from './editor/assignment-editor.view';
import { TimeLabelComponent } from './editor/time-label';
import { FileEntryComponent } from './editor/file-entry.component';
import { ComponentsModule } from '../components/components.module';
import { AuditModule } from '../audit/audit.module';
import { DialogModule } from '../dialog/dialog.module';

@NgModule({
    declarations: [
        AssignmentEditorComponent,
        TimeLabelComponent,
        FileEntryComponent,
        AssignmentEditorApp,
        AssignmentEditorView
    ],
    imports: [
        CommonModule,
        PipesModule,
        DirectivesModule,
        FormsModule,
        ReactiveFormsModule,
        ComponentsModule,
        AuditModule,
        DialogModule
    ],
    exports: [
        AssignmentEditorComponent,
        TimeLabelComponent,
        FileEntryComponent,
        AssignmentEditorApp,
        AssignmentEditorView
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AssignmentEditorModule {
  customElementComponent: Type<any> = AssignmentEditorApp;

  constructor() {}

  ngDoBootstrap() { }
}
